import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';

import TrendPivotChartActions from 'actions/calls/trend/TrendPivotChartActions';
import TrendPivotChartStore from 'stores/calls/trend/TrendPivotChartStore';

import TrendPivotChart from './TrendPivotChart';

class TrendPivotChartContainer extends React.Component {
  static getStores() {
    return [TrendPivotChartStore];
  }

  static getPropsFromStores() {
    const trendPivotState = TrendPivotChartStore.getState();
    return {trendPivotState};
  }

  componentDidMount() {
    // Grab the initial trend results for the current searchFields
    TrendPivotChartActions.searchTrend.defer();
  }

  render() {
    return (
      <AltContainer>
        <TrendPivotChart {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(TrendPivotChartContainer);
